import axios              from "axios";
import ReservationCC      from "../../../models/ReservationCC";
import {v4 as uuidv4}     from 'uuid';
import moment             from "moment";
import KioskReservation   from "./KioskReservation";

let model = {
    reservation: null,
    reservees: [],
    payment: ReservationCC(),
    cost: {
        'total_price': 0,
        'sub_total': 0,
        'total_addon_price': 0,
        'total_packages_price': 0,
        'amount_to_be_paid': 0,
        'tax': 0,
        'book_me_discount': null,
        'saved_by_coupon': 0
    }
}
export default async () => {
    try {
        let id = null;
        throw Error('Invalid response!');
        const response = await axios.get('/reservations/vue/load_reservation', {
            params: {
                id
            }
        });
        if (response.status === 200 && response.data && response.data.success) {


            model = response.data.data;
            model.reservation.email_confirmation = model.reservation.email;
            model.reservees = model.reservees.map(r => (
                    {
                        ...r,
                        _id: uuidv4(),
                        dob: moment(r.dob, 'MM/DD/YYYY').format('YYYY-MM-DD')
                    }
                )
            );
            model.reservation.reservees_number = model.reservees.length;
            model.payment = new ReservationCC();
            localStorage.setItem('last_reservation_id', model.reservation.id);
        } else {
            throw Error('Invalid response!');
        }
    } catch (e) {
        model.reservation = new KioskReservation();
    }
    return model;
}
